export const setWindowNID = (menu, path) => {
  for (var i in menu) {
    if (menu[i].url == path) {
      window.nid = menu[i].parentPath[0];
    }
    if (menu[i].child) {
      setWindowNID(menu[i].child, path);
    }
  }
};

function getMainHost() {
  let key = `mh_${Math.random()}`;
  let keyR = new RegExp(`(^|;)\\s*${key}=12345`);
  let expiredTime = new Date(0);
  let domain = location.host;
  let domainList = domain.split(".");

  let urlItems = [];
  // 主域名一定会有两部分组成
  urlItems.unshift(domainList.pop());
  // 慢慢从后往前测试
  while (domainList.length) {
    urlItems.unshift(domainList.pop());
    let mainHost = urlItems.join(".");
    let cookie = `${key}=${12345};domain=.${mainHost}`;

    document.cookie = cookie;

    //如果cookie存在，则说明域名合法
    if (keyR.test(document.cookie)) {
      document.cookie = `${cookie};expires=${expiredTime}`;
      return mainHost;
    }
  }
}
export const getCookieDomain = () => {
  let host = location.host;
  // 开发/测试环境
  if (host.indexOf("localhost") > -1 || host.indexOf("192") > -1) {
    return "localhost";
  } else {
    return getMainHost();
  }
};



// WEBPACK FOOTER //
// ./src/utils/config.js